import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";

import "./App.css";
import Header from './component/header';
import HomePage from './pages/HomePage';
import AboutUs from './pages/AboutUs';
import BODirector from './pages/BODirector';
import SmartVending from './pages/SmartVending';
import Career from './pages/Career';
import CareerPage from './pages/CareerList';
import ContactUs from './pages/ContactUs';
import CorporateResponsibility from './pages/CorporateResponsibility';
import InvestorRelay from './pages/InvestorRelay';
import TermsCondition from "./pages/termsCondition";
import PrivacyNotice from "./pages/PrivacyNotice";
import ScamAlert from "./pages/ScamAlert";
import RedirectHub from "./pages/RedirectHub";
import Race from "./pages/Race";
import VendorPrivacyNotice from "./pages/VendorPrivacyNotice";
import Notifications from "./pages/Notifications";


const App = () =>  {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="app-wrapper">
    
      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        <div className={`main-content ${isMenuOpen ? "shifted" : ""}`}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/aboutus" element={<AboutUs/>} />
            <Route path="/bod" element={<BODirector />} />
            {/* <Route path="/spacedx" element={<SmartVending/>}/> */}
            <Route path="/investorrelations" element={<InvestorRelay/>}/>
            <Route path="/careers" element={<Career/>}/>
            <Route path="/careerlist/*" element={<CareerPage/>}/>
            <Route path="/contactus" element={<ContactUs/>}/>
            <Route path="/corporate" element={<CorporateResponsibility/>}/>
            <Route path="/terms-condition" element={<TermsCondition/>}/>
            <Route path="/privacystatement" element={<PrivacyNotice/>} />
            <Route path="/scamalert" element={<ScamAlert/>} />
            <Route path="/prepaid-onebox" element={<RedirectHub />} />
            <Route path="/onexox-black" element={<RedirectHub />} />
            <Route path="/esim" element={<RedirectHub />} />
            <Route path="/volte" element={<RedirectHub />} />
            <Route path="/black-apps" element={<RedirectHub />} />
            <Route path="/e-commerce-epp" element={<RedirectHub />} />
            <Route path="/shop" element={<RedirectHub />} />
            <Route path="/checkout" element={<RedirectHub />} />
            <Route path="/my-account" element={<RedirectHub />} />
            <Route path="/blockchain" element={<RedirectHub />} />
            <Route path="/contact-us" element={<RedirectHub />} />
            <Route path="/join-our-industrial-training" element={<RedirectHub />} />
            <Route path="/application-form" element={<RedirectHub />} />
            <Route path="/home" element={<RedirectHub />} />
            <Route path="/telecommunications" element={<RedirectHub />} />
            <Route path="/adx" element={<RedirectHub />} />
            <Route path="/xox-city" element={<RedirectHub />} />
            <Route path="/space-x" element={<RedirectHub />} />
            <Route path="/sports" element={<RedirectHub />} />
            <Route path="/terms-conditions" element={<RedirectHub />} />
            <Route path="/terms-conditions/" element={<RedirectHub />} />
            <Route path="/privacyStatement/details/" element={<RedirectHub />} />
            <Route path="/internship-application-form" element={<RedirectHub />} />
            <Route path="/be-future-leaders-in-xox" element={<RedirectHub />} />
            <Route path="/join-our-professional-team" element={<RedirectHub />} />
            <Route path="/new-career" element={<RedirectHub />} />
            <Route path="/investor-relations" element={<RedirectHub />} />
            <Route path="/management-trainee" element={<RedirectHub />} />
            <Route path="/internship-2" element={<RedirectHub />} />
            <Route path="/leader" element={<RedirectHub />} />
            <Route path="/investor-relations-agm" element={<RedirectHub />} />
            <Route path="/scam-alert" element={<RedirectHub />} />
            <Route path="/fintech" element={<RedirectHub />} />
            <Route path="/black-app-survey" element={<RedirectHub />} />
            <Route path="/campaign-pdf" element={<RedirectHub />} />
            <Route path="/alliance-bank-xox-campaign" element={<RedirectHub />} />
            <Route path="/xox-black-app-x-foodpanda-2023" element={<RedirectHub />} />
            <Route path="/black-market-merchant-refer-and-reward" element={<RedirectHub />} />
            <Route path="/10561-2" element={<RedirectHub />} />
            <Route path="/whatsapp-tnc" element={<RedirectHub />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/10784-2" element={<RedirectHub />} />
            {/* <Route path="/race" element={<Race />} /> */}
            <Route path="/vendor/privacynotice" element={<VendorPrivacyNotice/>} />
          </Routes>
        </div>
    </div>
  );
}

export default App;
